export function getPersistencyEnabledState({ isPinned, isLocked }) {
  return Boolean(isPinned || isLocked);
}
